import { Mark, getMarkAttributes, mergeAttributes } from '@tiptap/core'

export interface TextStyleOptions {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customTextStyle: {
      setTextStyle(attrKey: string, value: string): () => ReturnType
      unsetTextStyle(attrKey: string): () => ReturnType
      /**
       * Remove spans without inline style attributes.
       */
      removeEmptyTextStyle: () => ReturnType
    }
  }
}

export const CustomTextStyle = Mark.create<TextStyleOptions>({
  name: 'customTextStyle',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        getAttrs: (element) => {
          const hasStyles = (element as HTMLElement).hasAttribute('style')

          if (!hasStyles) {
            return false
          }

          return {}
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  addCommands() {
    return {
      setTextStyle:
        (attrKey: string, value: string) =>
        ({ state, commands }) => {
          const { empty } = state.selection
          let attrs = {}

          if (empty && state.storedMarks) {
            const storedMark = state.storedMarks.find((markItem) => markItem.type.name === this.name)
            if (storedMark) {
              attrs = storedMark.attrs
            }
          }

          return commands.setMark(this.name, { ...attrs, [attrKey]: value })
        },
      unsetTextStyle:
        (attrKey: string) =>
        ({ state, commands, chain }) => {
          const { empty } = state.selection

          if (empty && state.storedMarks) {
            const storedMark = state.storedMarks.find((markItem) => markItem.type.name === this.name)
            if (storedMark) {
              return commands.setMark(this.name, { ...storedMark.attrs, [attrKey]: null })
            }
          }

          return chain()
            .setMark(this.name, { [attrKey]: null })
            .removeEmptyTextStyle()
            .run()
        },
      removeEmptyTextStyle:
        () =>
        // eslint-disable-next-line unicorn/consistent-function-scoping
        ({ state, commands }) => {
          const attributes = getMarkAttributes(state, this.type)
          // TODO need to create an issue
          const hasStyles = Object.entries(attributes).some(([, value]) => !!value)

          if (hasStyles) {
            return true
          }

          return commands.unsetMark(this.name)
        },
    }
  },
})
